// log.ts
import { environment } from '../../environments/environment';

let noop = () => {};

export const debug = !environment.production ? console.debug.bind(console) : noop;
export const info  = !environment.production ? console.info.bind(console)  : noop;
export const loggerDebug = !environment.production ? console.debug.bind(console) : noop;
export const loggerWarn  = !environment.production ? console.warn.bind(console)  : noop;
export const loggerError = !environment.production ? console.error.bind(console) : noop;
